import React from 'react'
import { I18n } from 'react-redux-i18n'

class FilterInfo extends React.Component {
  getDcpStatus () {
    let nodes = []
    nodes.push(<p key="dcpStatus"
                  className="filter-title qw-font-size-small qw-color-text-secondary-body qw-font-size-body clearfix">{I18n.t('compositions.dcpStatusTitle')}</p>)
    for (let status in I18n.t('compositions.dcpStatus')) {
      nodes.push(
        <div key={status}
             className={`filter-status qw-border qw-py-xxx-small qw-px-xx-small qw-rounded-small qw-font-size-xx-small left qw-line-height-small ${status}`}>
          {I18n.t(`compositions.dcpStatus.${status}`)}
        </div>
      )
    }
    return nodes
  }

  getKDMStatus () {

    let nodes = []
    nodes.push(<p key="kdmStatus"
                  className="filter-title qw-font-size-small qw-color-text-secondary-body qw-font-size-body clearfix">{I18n.t('compositions.kdmStatusTitle')}</p>)
    for (let status in I18n.t('compositions.kdmStatus')) {
      nodes.push(
        <div key={status}
             className={`filter-status qw-border qw-py-xxx-small qw-px-xx-small qw-rounded-small qw-font-size-xx-small left qw-line-height-small ${status}`}>
          {I18n.t(`compositions.kdmStatus.${status}`)}
        </div>
      )
    }
    return nodes
  }

  render () {
    return (
      <div className="filter-info">
        <div
          className="filter-status-wrap qw-mt-medium clearfix dcp-status"> {this.getDcpStatus()} </div>
        <div
          className="filter-status-wrap qw-mt-medium clearfix kdm-status"> {this.getKDMStatus()} </div>
      </div>
    )
  }
}

export default FilterInfo



// WEBPACK FOOTER //
// ./src/app/components/compositions/FilterInfo.js